import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-twitter",
  "use": "icon-twitter-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-twitter\">\n  <path id=\"icon-twitter_X_logo_HOVER_CLCIKED_\" data-name=\"X logo HOVER/CLCIKED \" d=\"M9.522,6.775,15.479,0H14.067L8.9,5.883,4.764,0H0L6.247,8.9,0,16H1.412L6.873,9.788,11.236,16H16L9.522,6.775Zm-1.933,2.2-.633-.886L1.92,1.04H4.088L8.152,6.728l.633.886,5.283,7.394H11.9L7.589,8.974Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/twitter.svg
// module id = 182
// module chunks = 0 1 2